const ABFieldBooleanCore = require("../../core/dataFields/ABFieldBooleanCore");
module.exports = class ABFieldBoolean extends ABFieldBooleanCore {};
